// Consts
export const CONFIRM_CUSTOM_TIME_RANGE = 'CONFIRM_CUSTOM_TIME_RANGE';
export const ON_REPORTS_MOUNT = 'ON_REPORTS_MOUNT';
export const ON_REPORTS_MOUNT_ERROR = 'ON_REPORTS_MOUNT_ERROR';
export const UPDATE_STATE_WITH_FETCHED_REPORT = 'UPDATE_STATE_WITH_FETCHED_REPORT';
export const UPDATE_STATE_WITH_FETCHED_COLUMNS = 'UPDATE_STATE_WITH_FETCHED_COLUMNS';
export const UPDATE_STATE_WITH_FETCHED_TEAM_MEMBERS = 'UPDATE_STATE_WITH_FETCHED_TEAM_MEMBERS';
export const CHECK_ALL_CHECKBOXES = 'CHECK_ALL_CHECKBOXES';
export const CHECK_DEFAULT_CHECKBOXES = 'CHECK_DEFAULT_CHECKBOXES';
export const ON_SCROLL_DONE = 'ON_SCROLL_DONE';
export const REPORTS_CLOSE_REPORT_MODAL = 'REPORTS_CLOSE_REPORT_MODAL';
export const REPORTS_OPEN_REPORT_MODAL = 'REPORTS_OPEN_REPORT_MODAL';
export const OPEN_QUICK_REPORT_MODAL = 'OPEN_QUICK_REPORT_MODAL';
export const OPEN_CUSTOM_REPORT_MODAL = 'OPEN_CUSTOM_REPORT_MODAL';
export const CLOSE_QUICK_REPORT_MODAL = 'CLOSE_QUICK_REPORT_MODAL';
export const OPEN_CUSTOM_REPORT_DELETE_MODAL = 'OPEN_CUSTOM_REPORT_DELETE_MODAL';
export const CLOSE_CUSTOM_REPORT_DELETE_MODAL = 'CLOSE_CUSTOM_REPORT_DELETE_MODAL';
export const OPEN_LARGE_REPORT_EMAIL_MODAL = 'OPEN_LARGE_REPORT_EMAIL_MODAL';
export const CLOSE_LARGE_REPORT_EMAIL_MODAL = 'CLOSE_LARGE_REPORT_EMAIL_MODAL';
export const SELECT_REPORT_FILE_TYPE = 'SELECT_REPORT_FILE_TYPE';
export const INCLUDE_EXTENDED_REPORT = 'INCLUDE_EXTENDED_REPORT';
export const REPORTS_DOWNLOAD_QUICK_REPORT = 'REPORTS_DOWNLOAD_QUICK_REPORT';
export const REPORTS_DOWNLOAD_QUICK_REPORT_SUCCESS = 'REPORTS_DOWNLOAD_QUICK_REPORT_SUCCESS';
export const REPORTS_DOWNLOAD_QUICK_REPORT_ERROR = 'REPORTS_DOWNLOAD_QUICK_REPORT_ERROR';
export const SELECT_QUICK_REPORT = 'SELECT_QUICK_REPORT';
export const SELECT_CUSTOM_REPORT = 'SELECT_CUSTOM_REPORT';
export const SELECT_REPORT_TIME_RANGE = 'SELECT_REPORT_TIME_RANGE';
export const SELECT_REPORT_DATE_FOCUS_CHANGE = 'SELECT_REPORT_DATE_FOCUS_CHANGE';
export const SELECT_REPORT_DATE_CUSTOM_TIME_CHOSEN = 'export const SELECT_REPORT_DATE_CUSTOM_TIME_CHOSEN';
export const SELECT_REPORT_DATE_CHANGE = 'SELECT_REPORT_DATE_CHANGE';
export const SELECT_REPORT_SINGLE_DATE_FOCUS_CHANGE = 'SELECT_REPORT_SINGLE_DATE_FOCUS_CHANGE';
export const SELECT_REPORT_SINGLE_DATE_CHANGE = 'SELECT_REPORT_SINGLE_DATE_CHANGE';
export const UPDATE_CUSTOM_REPORTS_PAGINATION = 'UPDATE_CUSTOM_REPORTS_PAGINATION';
export const UPDATE_CUSTOM_REPORTS_SEARCH = 'UPDATE_CUSTOM_REPORTS_SEARCH';
export const DELETE_CUSTOM_REPORT = 'DELETE_CUSTOM_REPORT';
export const ON_REPORTS_DELETE_SUCCESS = 'ON_REPORTS_DELETE_SUCCESS';
export const ON_REPORTS_DOWNLOAD_STARTED = 'ON_REPORTS_DOWNLOAD_STARTED';
export const ON_REPORTS_DOWNLOAD_SUCCESS = 'ON_REPORTS_DOWNLOAD_SUCCESS';
export const ON_REPORTS_DOWNLOAD_ERROR = 'ON_REPORTS_DOWNLOAD_ERROR';
export const ON_REPORTS_SAVE_STARTED = 'ON_REPORTS_SAVE_STARTED';
export const ON_REPORTS_SAVE_SUCCESS = 'ON_REPORTS_SAVE_SUCCESS';
export const ON_REPORT_TYPE_CHANGE = 'ON_REPORT_TYPE_CHANGE';
export const ON_REPORT_SORT_CHANGE = 'ON_REPORT_SORT_CHANGE';
export const ON_REPORT_NAME_CHANGE = 'ON_REPORT_NAME_CHANGE';
export const ON_REPORT_DESCRIPTION_CHANGE = 'ON_REPORT_DESCRIPTION_CHANGE';
export const ON_COLUMNS_CHECKBOX_CHANGE = 'ON_COLUMNS_CHECKBOX_CHANGE';
export const ON_FILTERS_PAYMENT_STATUS_CHANGE = 'ON_FILTERS_PAYMENT_STATUS_CHANGE';
export const ON_SORT_ALPHABETICALLY_CHANGE = 'ON_SORT_ALPHABETICALLY_CHANGE';
export const ON_REPORTS_SAVE_ERROR = 'ON_REPORTS_SAVE_ERROR';
export const ON_SORT_BY_DATE_CHANGE = 'ON_SORT_BY_DATE_CHANGE';
export const ON_CHANGE_SCOPE = 'ON_CHANGE_SCOPE';
export const ON_CLOSE_SELECT_EVENTS_MODAL_CLOSED = 'ON_CLOSE_SELECT_EVENTS_MODAL_CLOSED';
export const ON_VALIDATE_FORM_STARTED = 'ON_VALIDATE_FORM_STARTED';
export const ON_VALIDATE_FORM_SUCCESS = 'ON_VALIDATE_FORM_SUCCESS';
export const ON_VALIDATE_FORM_ERROR = 'ON_VALIDATE_FORM_ERROR';
export const ON_CREATE_REPORT_SUCCESS = 'ON_CREATE_REPORT_SUCCESS';

// Event Select Modal
export const ON_CUSTOM_REPORTS_TIME_FILTER_CHANGE = 'ON_CUSTOM_REPORTS_TIME_FILTER_CHANGE';
export const ON_CUSTOM_REPORTS_CUSTOM_TIME_CHOSEN = 'ON_CUSTOM_REPORTS_CUSTOM_TIME_CHOSEN';
export const ON_CUSTOM_REPORTS_CUSTOM_TIME_FOCUS_CHANGE = 'ON_CUSTOM_REPORTS_CUSTOM_TIME_FOCUS_CHANGE';
export const ON_CUSTOM_REPORTS_ALL_CURRENCY_SELECTED = 'ON_CUSTOM_REPORTS_ALL_CURRENCY_SELECTED';
export const ON_REPORTS_SELECT_CUSTOM_EVENTS_CLICKED = 'ON_REPORTS_SELECT_CUSTOM_EVENTS_CLICKED';
export const ON_REPORTS_TIME_FILTER_CHANGE = 'ON_REPORTS_TIME_FILTER_CHANGE';
export const ON_REPORTS_SELECT_CUSTOM_EVENTS_CLOSED = 'ON_REPORTS_SELECT_CUSTOM_EVENTS_CLOSED';
export const ON_REPORTS_SELECT_CUSTOM_EVENT_TOGGLED = 'ON_REPORTS_SELECT_CUSTOM_EVENT_TOGGLED';
export const ON_REPORTS_SELECT_ALL_EVENTS = 'ON_REPORTS_SELECT_ALL_EVENTS';
export const ON_REPORTS_SELECT_CUSTOM_EVENTS_SELECT_ALL_TOGGLED = 'ON_REPORTS_SELECT_CUSTOM_EVENTS_SELECT_ALL_TOGGLED';
export const ON_REPORTS_SELECTED_CURRENCY_CHANGE = 'ON_REPORTS_SELECTED_CURRENCY_CHANGE';
export const ON_REPORTS_SELECT_CUSTOM_EVENTS_COMPLETE = 'ON_REPORTS_SELECT_CUSTOM_EVENTS_COMPLETE';
export const ON_REPORTS_SHOW_ALL_EVENTS_CLICKED = 'ON_REPORTS_SHOW_ALL_EVENTS_CLICKED';
export const ON_REPORTS_SET_CUSTOM_EVENTS = 'ON_REPORTS_SET_CUSTOM_EVENTS';
export const ON_REPORTS_ORGANIZATION_CHANGE = 'ON_REPORTS_ORGANIZATION_CHANGE';

export const ON_REPORTS_CUSTOM_DATE_FOCUS_CHANGE = 'ON_REPORTS_CUSTOM_DATE_FOCUS_CHANGE';
export const ON_REPORTS_CUSTOM_DATE_CHOSEN = 'ON_REPORTS_CUSTOM_DATE_CHOSEN';

// Modal
export const SELECT_DATE_ORDER_TIME_RANGE = 'SELECT_DATE_ORDER_TIME_RANGE';
export const SELECT_DATE_ATTENDING_TIME_RANGE = 'SELECT_DATE_ATTENDING_TIME_RANGE';
export const SELECT_DATE_OF_ORDER_FOCUS_CHANGE = 'SELECT_DATE_OF_ORDER_FOCUS_CHANGE';
export const SELECT_DATE_OF_ATTENDING_FOCUS_CHANGE = 'SELECT_DATE_OF_ATTENDING_FOCUS_CHANGE';
export const SELECT_DATE_OF_ORDER_CHANGE = 'SELECT_DATE_OF_ORDER_CHANGE';
export const SELECT_DATE_OF_ATTENDING_CHANGE = 'SELECT_DATE_OF_ATTENDING_CHANGE';
export const SELECT_DATE_OF_ORDER_SINGLE_DATE_FOCUS_CHANGE = 'SELECT_DATE_OF_ORDER_SINGLE_DATE_FOCUS_CHANGE';
export const SELECT_DATE_OF_ATTENDING_SINGLE_DATE_FOCUS_CHANGE = 'SELECT_DATE_OF_ATTENDING_SINGLE_DATE_FOCUS_CHANGE';
export const SELECT_DATE_OF_ORDER_SINGLE_DATE_CHANGE = 'SELECT_DATE_OF_ORDER_SINGLE_DATE_CHANGE';
export const SELECT_DATE_OF_ATTENDING_SINGLE_DATE_CHANGE = 'SELECT_DATE_OF_ATTENDING_SINGLE_DATE_CHANGE';
export const ON_REPORT_SAVE_DATE_OF_ORDER = 'ON_REPORT_SAVE_DATE_OF_ORDER';
export const ON_REPORT_SAVE_DATE_OF_ATTENDING = 'ON_REPORT_SAVE_DATE_OF_ATTENDING';

export const CONFIRM_REPORT_SCHEDULER_DATE_RANGE = 'CONFIRM_REPORT_SCHEDULER_DATE_RANGE';
export const ON_REPORT_SCHEDULER_DATE_RANGE_CHOSEN = 'ON_REPORT_SCHEDULER_DATE_RANGE_CHOSEN';
export const ON_REPORT_SCHEDULER_DATE_RANGE_FOCUS_CHANGE = 'ON_REPORT_SCHEDULER_DATE_RANGE_FOCUS_CHANGE';
export const ON_REPORT_SCHEDULER_DATE_RANGE_CHANGE = 'ON_REPORT_SCHEDULER_DATE_RANGE_CHANGE';
export const ON_REPORT_SCHEDULER_FREQUENCY_CHANGE = 'ON_REPORT_SCHEDULER_FREQUENCY_CHANGE';
export const ON_REPORT_SCHEDULER_TIME_CHANGE = 'ON_REPORT_SCHEDULER_TIME_CHANGE';
export const ON_REPORT_SCHEDULER_TOGGLE = 'ON_REPORT_SCHEDULER_TOGGLE';
export const ON_REPORT_SCHEDULER_HOUR_CHANGE = 'ON_REPORT_SCHEDULER_HOUR_CHANGE';
export const ON_REPORT_SCHEDULER_DAY_CHANGE = 'ON_REPORT_SCHEDULER_DAY_CHANGE';
export const ON_ADDITIONAL_RECIPIENTS_CHANGE = 'ON_ADDITIONAL_RECIPIENTS_CHANGE';
export const ON_EXTERNAL_RECIPIENT_EMAILS_CHANGE = 'ON_EXTERNAL_RECIPIENT_EMAILS_CHANGE';

// Initialization
export const onReportsMount = () => ({
  type: ON_REPORTS_MOUNT
});

export const confirmCustomTimeRange = (value) => ({
  type: CONFIRM_CUSTOM_TIME_RANGE,
  payload: value
});

export const updateStateWithFetchedReport = (fetchedReport) => ({
  type: UPDATE_STATE_WITH_FETCHED_REPORT,
  payload: { fetchedReport }
});

export const updateStateWithFetchedColumns = (fetchedColumns) => ({
  type: UPDATE_STATE_WITH_FETCHED_COLUMNS,
  payload: { fetchedColumns }
});

export const updateStateWithFetchedTeamMembers = (fetchedTeamMembers) => ({
  type: UPDATE_STATE_WITH_FETCHED_TEAM_MEMBERS,
  payload: { fetchedTeamMembers }
});

export const checkAllCheckboxes = (fetchedColumns) => ({
  type: CHECK_ALL_CHECKBOXES,
  payload: fetchedColumns
});

export const checkDefaultCheckboxes = (defaultCheckboxesData) => ({
  type: CHECK_DEFAULT_CHECKBOXES,
  payload: defaultCheckboxesData
});

export const scrollDone = () => ({
  type: ON_SCROLL_DONE
});

export const saveDateOfOrder = () => ({
  type: ON_REPORT_SAVE_DATE_OF_ORDER
});

export const saveDateOfAttending = () => ({
  type: ON_REPORT_SAVE_DATE_OF_ATTENDING
});

export const validateForm = () => ({
  type: ON_VALIDATE_FORM_STARTED
});

export const saveReport = (createReport, updateReport, customGeneral, customFilters, customSorts, selectedEventIDs, customScheduler, eventFilter) => ({
  type: ON_REPORTS_SAVE_STARTED,
  payload: {
    createReport,
    updateReport,
    customGeneral,
    customFilters,
    customSorts,
    selectedEventIDs,
    customScheduler,
    eventFilter
  }
});

// onChanges
export const onReportTypeChange = (val) => ({
  type: ON_REPORT_TYPE_CHANGE,
  payload: val
});

export const onReportSortChange = (val) => ({
  type: ON_REPORT_SORT_CHANGE,
  payload: val
});

export const onReportNameChange = (val) => ({
  type: ON_REPORT_NAME_CHANGE,
  payload: val
});

export const onReportDescriptionChange = (val) => ({
  type: ON_REPORT_DESCRIPTION_CHANGE,
  payload: val
});

export const onColumnsCheckboxChange = (val) => ({
  type: ON_COLUMNS_CHECKBOX_CHANGE,
  payload: val
});

export const onFiltersPaymentStatusChange = (val) => {
  return {
    type: ON_FILTERS_PAYMENT_STATUS_CHANGE,
    payload: val
  };
};

export const onSortAlphabeticallyChange = (val) => ({
  type: ON_SORT_ALPHABETICALLY_CHANGE,
  payload: val
});

export const onSortByDateChange = (val) => ({
  type: ON_SORT_BY_DATE_CHANGE,
  payload: val
});

export const changeScope = () => ({
  type: ON_CHANGE_SCOPE
});

export const onCloseSelectEventsModalClosed = () => ({
  type: ON_CLOSE_SELECT_EVENTS_MODAL_CLOSED
});

export const updateCustomReportsPagination = (limit, offset, currentPage) => {
  return {
    type: UPDATE_CUSTOM_REPORTS_PAGINATION,
    payload: { limit, offset, currentPage }
  };
};

export const updateCustomReportsSearch = (searchText) => {
  return {
    type: UPDATE_CUSTOM_REPORTS_SEARCH,
    payload: { searchText }
  };
};

export const deleteCustomReport = (deleteMutation, gqlQueryObj, id, limit, offset, currentPage) => {
  return {
    type: DELETE_CUSTOM_REPORT,
    payload: { deleteMutation, gqlQueryObj, id, limit, offset, currentPage }
  };
};

export const selectQuickReport = (reportSelectedTitle, reportSelectedId) => {
  return {
    type: SELECT_QUICK_REPORT,
    payload: { reportSelectedTitle, reportSelectedId }
  };
};

export const selectCustomReport = (id, fileType) => {
  return {
    type: SELECT_CUSTOM_REPORT,
    payload: { id, fileType }
  };
};

// Modals
export const openQuickReportModal = (reportSelectedTitle, reportSelectedId) => {
  return {
    type: OPEN_QUICK_REPORT_MODAL,
    payload: { reportSelectedTitle, reportSelectedId }
  };
};

export const closeQuickReportModal = () => {
  return {
    type: CLOSE_QUICK_REPORT_MODAL
  };
};

export const openCustomReportDeleteModal = (id) => {
  return {
    type: OPEN_CUSTOM_REPORT_DELETE_MODAL,
    payload: id
  };
};

export const closeCustomReportDeleteModal = () => {
  return {
    type: CLOSE_CUSTOM_REPORT_DELETE_MODAL
  };
};

export const openLargeReportEmailModal = () => {
  return {
    type: OPEN_LARGE_REPORT_EMAIL_MODAL,
  };
};

export const closeLargeReportEmailModal = () => {
  return {
    type: CLOSE_LARGE_REPORT_EMAIL_MODAL,
  };
};

export const selectReportFileType = (id, reportFileType, reportType) => {
  return {
    type: SELECT_REPORT_FILE_TYPE,
    payload: { id, reportFileType, reportType }
  };
};

export const toggleExtendedAuditReport = (includeExtendedAudit) => {
  return {
    type: INCLUDE_EXTENDED_REPORT,
    payload: { includeExtendedAudit }
  };
};

export const downloadCustomReport = (report) => {
  return {
    type: ON_REPORTS_DOWNLOAD_STARTED,
    payload: { report }
  };
};

export const downloadQuickReport = () => {
  return {
    type: REPORTS_DOWNLOAD_QUICK_REPORT
  };
};

export const onCustomReportsCustomTimeChosen = item => {
  return {
    type: ON_CUSTOM_REPORTS_CUSTOM_TIME_CHOSEN,
    payload: item
  };
};

export const onCustomReportsCustomTimeFocusChange = item => {
  return {
    type: ON_CUSTOM_REPORTS_CUSTOM_TIME_FOCUS_CHANGE,
    payload: !item ? 'startDate' : item
  };
};

export const onCustomReportsTimeFilterChange = item => {
  return {
    type: ON_CUSTOM_REPORTS_TIME_FILTER_CHANGE,
    payload: item
  };
};

export const selectReportTimeRange = item => {
  return {
    type: SELECT_REPORT_TIME_RANGE,
    payload: item
  };
};

export const onReportCustomDateChosen = item => {
  return {
    type: ON_REPORTS_CUSTOM_DATE_CHOSEN,
    payload: item
  };
};

export const onReportCustomDateFocusChange = item => {
  return {
    type: SELECT_REPORT_DATE_FOCUS_CHANGE,
    payload: !item ? 'startDate' : item
  };
};

export const onReportCustomDateChange = item => {
  return {
    type: SELECT_REPORT_DATE_CHANGE,
    payload: item
  };
};

export const onReportSingleDateFocusChange = item => {
  return {
    type: SELECT_REPORT_SINGLE_DATE_FOCUS_CHANGE,
    payload: item
  };
};

export const onReportSingleDateChange = item => {
  return {
    type: SELECT_REPORT_SINGLE_DATE_CHANGE,
    payload: item
  };
};

export const selectDateOfOrderTimeRange = item => {
  return {
    type: SELECT_DATE_ORDER_TIME_RANGE,
    payload: item.value
  };
};

export const selectDateOfAttendingTimeRange = item => {
  return {
    type: SELECT_DATE_ATTENDING_TIME_RANGE,
    payload: item.value
  };
};

export const onDateOfOrderCustomFocusChange = item => {
  return {
    type: SELECT_DATE_OF_ORDER_FOCUS_CHANGE,
    payload: !item ? 'startDate' : item
  };
};

export const onDateOfAttendingCustomFocusChange = item => {
  return {
    type: SELECT_DATE_OF_ATTENDING_FOCUS_CHANGE,
    payload: !item ? 'startDate' : item
  };
};

export const onDateOfOrderCustomDateChange = item => {
  return {
    type: SELECT_DATE_OF_ORDER_CHANGE,
    payload: item
  };
};

export const onDateOfAttendingCustomDateChange = item => {
  return {
    type: SELECT_DATE_OF_ATTENDING_CHANGE,
    payload: item
  };
};

export const onDateOfOrderSingleDateFocusChange = item => {
  return {
    type: SELECT_DATE_OF_ORDER_SINGLE_DATE_FOCUS_CHANGE,
    payload: item
  };
};

export const onDateOfAttendingSingleDateFocusChange = item => {
  return {
    type: SELECT_DATE_OF_ATTENDING_SINGLE_DATE_FOCUS_CHANGE,
    payload: item
  };
};

export const onDateOfOrderSingleDateChange = item => {
  return {
    type: SELECT_DATE_OF_ORDER_SINGLE_DATE_CHANGE,
    payload: item
  };
};

export const onDateOfAttendingSingleDateChange = item => {
  return {
    type: SELECT_DATE_OF_ATTENDING_SINGLE_DATE_CHANGE,
    payload: item
  };
};

// Event Select Modal
export const onSelectCustomEventsClicked = () => {
  return {
    type: ON_REPORTS_SELECT_CUSTOM_EVENTS_CLICKED
  };
};

export const onReportsTimeFilterChange = (value) => ({
  type: ON_REPORTS_TIME_FILTER_CHANGE,
  payload: value
});

export const onSelectCustomEventsClosed = () => {
  return {
    type: ON_REPORTS_SELECT_CUSTOM_EVENTS_CLOSED
  };
};

export const onSelectCustomEventToggled = (event, id) => {
  return {
    type: ON_REPORTS_SELECT_CUSTOM_EVENT_TOGGLED,
    payload: { event, id }
  };
};

export const onSelectAllEvents = () => {
  return {
    type: ON_REPORTS_SELECT_ALL_EVENTS
  };
};

export const onSelectAllToggled = (events, ids, addToState) => {
  return {
    type: ON_REPORTS_SELECT_CUSTOM_EVENTS_SELECT_ALL_TOGGLED,
    payload: { events, ids },
    meta: { addToState }
  };
};

export const onSelectedCurrencyChange = (currency) => ({
  type: ON_REPORTS_SELECTED_CURRENCY_CHANGE,
  payload: currency
});

export const onSelectCustomEventsComplete = () => {
  return {
    type: ON_REPORTS_SELECT_CUSTOM_EVENTS_COMPLETE
  };
};

export const onShowAllEventsClicked = () => {
  return {
    type: ON_REPORTS_SHOW_ALL_EVENTS_CLICKED
  };
};

export const onOrganizationChange = (ownerId, currencies) => {
  return {
    type: ON_REPORTS_ORGANIZATION_CHANGE,
    payload: { ownerId, currencies }
  };
};

export const onReportSchedulerTimeChange = (time) => {
  return {
    type: ON_REPORT_SCHEDULER_TIME_CHANGE,
    payload: time
  };
};

export const onReportSchedulerFrequencyChange = (freq) => {
  return {
    type: ON_REPORT_SCHEDULER_FREQUENCY_CHANGE,
    payload: freq
  };
};

export const onReportSchedulerDateRangeChange = (dateRange) => {
  return {
    type: ON_REPORT_SCHEDULER_DATE_RANGE_CHANGE,
    payload: dateRange
  };
};

export const onReportSchedulerDateRangeFocusChange = (focus) => {
  return {
    type: ON_REPORT_SCHEDULER_DATE_RANGE_FOCUS_CHANGE,
    payload: !focus ? 'startDate' : focus
  };
};

export const onReportSchedulerDateRangeChosen = (dateRange) => {
  return {
    type: ON_REPORT_SCHEDULER_DATE_RANGE_CHOSEN,
    payload: dateRange
  };
};

export const confirmReportSchedulerDateRange = (dateRange) => {
  return {
    type: CONFIRM_REPORT_SCHEDULER_DATE_RANGE,
    payload: dateRange
  };
};

export const onReportSchedulerToggle = () => {
  return {
    type: ON_REPORT_SCHEDULER_TOGGLE
  };
};

export const onReportSchedulerHourChange = (hour) => {
  return {
    type: ON_REPORT_SCHEDULER_HOUR_CHANGE,
    payload: hour
  };
};

export const onReportSchedulerDayChange = (day) => {
  return {
    type: ON_REPORT_SCHEDULER_DAY_CHANGE,
    payload: day
  };
};

export const onAdditionalRecipientsChange = (ids) => ({
  type: ON_ADDITIONAL_RECIPIENTS_CHANGE,
  payload: ids
});

export const onExternalRecipientEmailsChange = (emails) => ({
  type: ON_EXTERNAL_RECIPIENT_EMAILS_CHANGE,
  payload: emails
});



// WEBPACK FOOTER //
// ./src/modules/reports/actions.js